import React, { useState } from 'react';
import { Bell, Mail, MessageCircle, Send, Save, CheckCircle } from 'lucide-react';

const NotificationsSettings = () => {
  const [saved, setSaved] = useState(false);
  const [settings, setSettings] = useState({
    email_notifications: true,
    sms_notifications: false,
    telegram_notifications: true,
    new_visitor_alert: true,
    fuel_sale_alert: true,
    landing_alert: true,
    daily_summary: false
  });

  const handleSave = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <div className="bg-gray-800/50 rounded-xl border border-gray-700 overflow-hidden p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-white">Notifications</h3>
          <p className="text-gray-400 text-sm">Configure how you receive alerts and notifications</p>
        </div>
        <button
          onClick={handleSave}
          className="flex items-center gap-2 px-4 py-2 bg-blue-500 hover:bg-blue-600 rounded-lg text-white"
        >
          <Save className="w-4 h-4" />
          Save Preferences
        </button>
      </div>

      {saved && (
        <div className="mb-4 p-3 rounded-lg bg-green-500/20 text-green-400 border border-green-500/30">
          <CheckCircle className="w-4 h-4 inline mr-2" />
          Preferences saved successfully!
        </div>
      )}

      <div className="space-y-6">
        {/* Channels */}
        <div>
          <h4 className="text-white font-medium mb-3 flex items-center gap-2">
            <Send className="w-4 h-4" /> Notification Channels
          </h4>
          <div className="space-y-3">
            <label className="flex items-center justify-between p-3 bg-gray-900/50 rounded-lg cursor-pointer">
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-blue-400" />
                <div>
                  <span className="text-white">Email Notifications</span>
                  <p className="text-xs text-gray-500">Receive notifications via email</p>
                </div>
              </div>
              <input
                type="checkbox"
                checked={settings.email_notifications}
                onChange={(e) => setSettings({ ...settings, email_notifications: e.target.checked })}
                className="w-5 h-5 rounded border-gray-600 text-blue-500 focus:ring-blue-500"
              />
            </label>

            <label className="flex items-center justify-between p-3 bg-gray-900/50 rounded-lg cursor-pointer">
              <div className="flex items-center gap-3">
                <MessageCircle className="w-5 h-5 text-green-400" />
                <div>
                  <span className="text-white">Telegram Notifications</span>
                  <p className="text-xs text-gray-500">Receive notifications via Telegram</p>
                </div>
              </div>
              <input
                type="checkbox"
                checked={settings.telegram_notifications}
                onChange={(e) => setSettings({ ...settings, telegram_notifications: e.target.checked })}
                className="w-5 h-5 rounded border-gray-600 text-blue-500 focus:ring-blue-500"
              />
            </label>

            <label className="flex items-center justify-between p-3 bg-gray-900/50 rounded-lg cursor-pointer">
              <div className="flex items-center gap-3">
                <Bell className="w-5 h-5 text-yellow-400" />
                <div>
                  <span className="text-white">SMS Notifications</span>
                  <p className="text-xs text-gray-500">Receive notifications via SMS</p>
                </div>
              </div>
              <input
                type="checkbox"
                checked={settings.sms_notifications}
                onChange={(e) => setSettings({ ...settings, sms_notifications: e.target.checked })}
                className="w-5 h-5 rounded border-gray-600 text-blue-500 focus:ring-blue-500"
              />
            </label>
          </div>
        </div>

        {/* Events */}
        <div>
          <h4 className="text-white font-medium mb-3 flex items-center gap-2">
            <Bell className="w-4 h-4" /> Events to Notify
          </h4>
          <div className="space-y-3">
            <label className="flex items-center justify-between p-3 bg-gray-900/50 rounded-lg cursor-pointer">
              <span className="text-white">New Visitor Detected</span>
              <input
                type="checkbox"
                checked={settings.new_visitor_alert}
                onChange={(e) => setSettings({ ...settings, new_visitor_alert: e.target.checked })}
                className="w-5 h-5 rounded border-gray-600 text-blue-500 focus:ring-blue-500"
              />
            </label>

            <label className="flex items-center justify-between p-3 bg-gray-900/50 rounded-lg cursor-pointer">
              <span className="text-white">Fuel Sale Completed</span>
              <input
                type="checkbox"
                checked={settings.fuel_sale_alert}
                onChange={(e) => setSettings({ ...settings, fuel_sale_alert: e.target.checked })}
                className="w-5 h-5 rounded border-gray-600 text-blue-500 focus:ring-blue-500"
              />
            </label>

            <label className="flex items-center justify-between p-3 bg-gray-900/50 rounded-lg cursor-pointer">
              <span className="text-white">Landing/Takeoff Detected</span>
              <input
                type="checkbox"
                checked={settings.landing_alert}
                onChange={(e) => setSettings({ ...settings, landing_alert: e.target.checked })}
                className="w-5 h-5 rounded border-gray-600 text-blue-500 focus:ring-blue-500"
              />
            </label>

            <label className="flex items-center justify-between p-3 bg-gray-900/50 rounded-lg cursor-pointer">
              <span className="text-white">Daily Summary Report</span>
              <input
                type="checkbox"
                checked={settings.daily_summary}
                onChange={(e) => setSettings({ ...settings, daily_summary: e.target.checked })}
                className="w-5 h-5 rounded border-gray-600 text-blue-500 focus:ring-blue-500"
              />
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationsSettings;